<div class="group"
        [ngClass]="{'group-valid': isValid, 'group-invalid': !isValid}">
    <div fxLayout="row" fxLayoutAlign="space-between">
        <div fxFlex="50" class="group-name">{{group.groupName}}</div>
        <div fxFlex="40" class="dep-rule-name">Group type: {{getFriendlyGroupType()}}</div>
        <div>
            <button mat-icon-button
                    class="edit-button"
                    (click)="editGroup()"
                    title="Edit the details and mappings for the '{{group.groupName}}'' accrual/prepayment group">
                <app-icon-core icon="edit"></app-icon-core>
            </button>
        </div>
    </div>
    <div fxLayout="row"  style="margin-bottom: 10px;">
       <div fxFlex="50*">
            <app-group-edit-section [section]="section" [selectedSection]="selectedSection"
                [dialogMode]="false"
                [subSection]="true">
            </app-group-edit-section>
        </div>
        
    </div>
</div>
